import { Card, Col, Descriptions, Row } from "antd";

export default function TabDetalhesOS({ ordemservico }) {

    return (
        <div>
            <Row align="middle" justify="space-between">
                <Col span={12}>
                    <Card>
                        <Descriptions size="small">
                            <Descriptions.Item label="Descrição Problema relatado pelo Cliente" labelStyle={{ fontWeight: 'bold' }}>
                                {(ordemservico.orv_descricaoproblema)}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                    <Card>
                        <Descriptions size="small">
                            <Descriptions.Item label="Serviço realizado" labelStyle={{ fontWeight: 'bold' }}>
                                {(ordemservico.orv_descricaoservico)}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                    <Card>
                        <Descriptions size="small">
                            <Descriptions.Item label="Placa" labelStyle={{ fontWeight: 'bold' }}>
                                {(ordemservico.orv_placa)}
                            </Descriptions.Item>
                        </Descriptions>
                    </Card>
                </Col>
            </Row>
        </div >
    );

}